import { AppState } from '@/types';

export const createPetCollectionActions = (state: AppState, dispatch: any) => {
  const hatchPet = (eggId: string, potionId: string) => {
    dispatch({ type: 'HATCH_PET', payload: { eggId, potionId } });
  };

  const feedPetCollection = (petId: string, foodKey: string, quantity: number = 1) => {
    dispatch({ type: 'FEED_PET_COLLECTION', payload: { petId, foodKey, quantity } });
  };

  const evolvePetToMount = (petId: string) => {
    dispatch({ type: 'EVOLVE_PET_TO_MOUNT', payload: { petId } });
  };

  const equipPet = (petId: string) => {
    dispatch({ type: 'EQUIP_PET', payload: { petId } });
  };

  const equipMount = (mountId: string) => {
    dispatch({ type: 'EQUIP_MOUNT', payload: { mountId } });
  };

  const unequipPet = () => {
    dispatch({ type: 'UNEQUIP_PET' });
  };

  const unequipMount = () => {
    dispatch({ type: 'UNEQUIP_MOUNT' });
  };

  const addInventoryItem = (itemType: 'egg' | 'potion' | 'food', itemKey: string, quantity: number = 1) => {
    dispatch({ type: 'ADD_INVENTORY_ITEM', payload: { itemType, itemKey, quantity } });
  };

  const removeInventoryItem = (itemId: string, quantity: number = 1) => {
    dispatch({ type: 'REMOVE_INVENTORY_ITEM', payload: { itemId, quantity } });
  };

  const initializePetCollection = () => {
    dispatch({ type: 'INITIALIZE_PET_COLLECTION' });
  };

  const loadPetCollection = (collection: any) => {
    dispatch({ type: 'LOAD_PET_COLLECTION', payload: { collection } });
  };

  const equipClothing = (clothingItem: string) => {
    dispatch({ type: 'EQUIP_CLOTHING', payload: { clothingItem } });
  };

  return {
    hatchPet,
    feedPetCollection,
    evolvePetToMount,
    equipPet,
    equipMount,
    unequipPet,
    unequipMount,
    addInventoryItem,
    removeInventoryItem,
    initializePetCollection,
    loadPetCollection,
    equipClothing
  };
};